import { SCROLL_HEIGHT_PER_SLIDE } from '../const';

export const getSectionHeightVh = (slidesCount: number): number =>
	(1 + Math.max(slidesCount - 1, 0) * SCROLL_HEIGHT_PER_SLIDE) * 100;
